import React, {FunctionComponent, useContext} from 'react';
import "./ActivitySection.scss"
import {SectionPreloader} from "../../components/SectionPreloader/SectionPreloader";
import {ActivityContext} from "../../context/ActivityContext";
import {Activity} from "../../models/activity.model";
import {ActivityTile} from "../../components/ActivityTile/ActivityTile";

export const ActivitySection: FunctionComponent = () => {
    const activityContext = useContext(ActivityContext);

    return (
        <section className='basic-section activity-section'>
            <h3>Activity</h3>

            <div className="activity-container">
                {!activityContext.isActivityLoading ? <div>
                    {activityContext.activity.map((activity: Activity) => {
                        return <ActivityTile activity={activity}/>
                    })}
                </div> : <SectionPreloader/>}
            </div>
        </section>
    );
};